import { render, staticRenderFns } from "./display-field-badge.vue?vue&type=template&id=8fa3657e&scoped=true&"
import script from "./display-field-badge.ts?vue&type=script&lang=ts&"
export * from "./display-field-badge.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-badge.scss?vue&type=style&index=0&id=8fa3657e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa3657e",
  null
  
)

export default component.exports